import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const AttachLinkIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 16 16"
    >
      <path
        d="M14.3333 2.45334L13.5533 1.67334C12.2133 0.340007 10.04 0.340007 8.70663 1.67334L6.5133 3.86667C6.2533 4.12667 6.2533 4.54667 6.5133 4.80667C6.7733 5.06667 7.1933 5.06667 7.4533 4.80667L9.64663 2.61334C10.46 1.80001 11.7933 1.79334 12.6066 2.61334L13.3866 3.39334C14.2066 4.21334 14.2066 5.54001 13.3866 6.35334L11.0466 8.69334C10.2266 9.51334 8.89996 9.50667 8.08663 8.69334L7.30663 7.91334C7.04663 7.65334 6.62663 7.65334 6.36663 7.91334C6.10663 8.17334 6.10663 8.59334 6.36663 8.85334L7.14663 9.63334C7.8133 10.3 8.6933 10.6333 9.5733 10.6333C10.4533 10.6333 11.3266 10.3 12 9.63334L14.34 7.29334C14.9866 6.64667 15.3466 5.78667 15.3466 4.86667C15.3466 3.94667 14.9866 3.08667 14.34 2.44001L14.3333 2.45334Z"
        fill={color}
      />
      <path
        d="M8.54663 11.1934L6.35329 13.3867C5.53329 14.2 4.20663 14.2 3.39329 13.3867L2.61329 12.6067C1.79996 11.7867 1.79996 10.46 2.61329 9.6467L4.95996 7.3067C5.77996 6.49337 7.10663 6.49337 7.91996 7.3067L8.69996 8.0867C8.95996 8.3467 9.37996 8.3467 9.63996 8.0867C9.89996 7.8267 9.89996 7.4067 9.63996 7.1467L8.85996 6.3667C7.52663 5.03337 5.34663 5.03337 4.01329 6.3667L1.66663 8.7067C0.333293 10.04 0.333293 12.22 1.66663 13.5534L2.44663 14.3334C3.09329 14.98 3.95329 15.34 4.87329 15.34C5.79329 15.34 6.65329 14.98 7.29996 14.3334L9.49329 12.14C9.75329 11.88 9.75329 11.46 9.49329 11.2C9.23329 10.94 8.81329 10.94 8.55329 11.2L8.54663 11.1934Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

AttachLinkIcon.displayName = 'AttachLinkIcon';
